import LikeCommentButton from "../likeCommentButton/LikeCommentButton";
import ReplyButton from "../replyButton/ReplyButton";
import style from "./Replies.module.css";

import ReplyForm from "../replyForm/ReplyForm";

import { formatTimeAgo } from "@/i18n/format";
import { useCurrentLanguage, useLocalized } from "@/i18n/useLocalized";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import MoreOptions from "../moreOptions/MoreOptions";

function Replies({ user, unit, comment }) {
	const [replyingTo, setReplyingTo] = useState(null);
	const language = useCurrentLanguage();
	const l = useLocalized();
	const { t } = useTranslation();

	return (
		<ul>
			{comment.replies.map((reply) => (
				<li key={reply.uuid} className={style.reply}>
					<div className={style.header}>
						<div className={style.userInfo}>
							<img src={reply.user?.safe_picture_url} />
							<span className={style.username}>
								{reply.user?.is_deleted
									? t("common:deletedUser")
									: reply.user?.username}
							</span>
							<span className={style.sep}></span>
							<span className={style.timestamp}>
								{formatTimeAgo(reply.timestamp, language)}
							</span>
						</div>
						<div className={style.more}>
							{(reply?.user?.username == user?.username ||
								user?.role == "admin") && (
								<MoreOptions unit={unit} comment={reply} />
							)}
						</div>
					</div>
					<div className={style.body}>
						<span className={style.content}>{l(reply, "content")}</span>
					</div>

					<div className={style.footer}>
						<ReplyButton
							setIsReplying={() =>
								setReplyingTo(
									replyingTo === reply.uuid
										? null
										: reply.uuid
								)
							}
							isReplying={replyingTo === reply.uuid}
							commentId={reply.uuid}
							replyingTo={replyingTo}
						/>
						<LikeCommentButton comment={reply} />
					</div>
					{replyingTo === reply.uuid && (
						<ReplyForm
							comment={comment}
							unit={unit}
							isReplying={true}
							setIsReplying={() => setReplyingTo(null)}
						/>
					)}
				</li>
			))}
		</ul>
	);
}

export default Replies;
